import * as i from "@sentry/react";
import { DEFAULT_IGNORE_ERRORS_LIST as S, DEFAULT_IGNORE_ERROR_SOURCES_LIST as m } from "./SentryMonitoring.consts.mjs";
class R {
  constructor(e) {
    this.initialized = !1, this.params = e;
  }
  init() {
    const { dsn: e, environment: r = "development", release: a = "development", production: f = !1, configure: c } = this.params;
    if (!e || r === "development" || a === "development")
      return Promise.resolve();
    try {
      const t = {
        environment: r,
        release: a,
        dsn: e,
        ignoreErrors: [...S],
        integrations: [new i.BrowserTracing()],
        tracesSampleRate: f ? 0.1 : 1,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1,
        beforeSend: (l, n) => {
          var p;
          const o = (p = n == null ? void 0 : n.originalException) == null ? void 0 : p.stack;
          return o && m.some((s) => typeof s == "string" ? o.indexOf(s) !== -1 : s.test(o)) ? null : l;
        }
      }, u = typeof c == "function" ? c(t) : t;
      i.init(u);
    } catch (t) {
      console.error("Cannot initialize SentryMonitoring: ", t);
    }
    return this.initialized = !0, Promise.resolve();
  }
  setClientId(e) {
    if (!this.initialized) {
      console.info("Setting client ID:", e);
      return;
    }
    i.configureScope((r) => r.setTag("client_id", e));
  }
  captureError(e, r) {
    if (!this.initialized) {
      console.error(e);
      return;
    }
    r ? i.captureException(e, r) : i.captureException(e);
  }
}
export {
  R as SentryMonitoring
};
//# sourceMappingURL=SentryMonitoring.mjs.map
